import type { UserType } from "@shared/types/user";
import { getAllRoles } from "@shared/utils/getAllRoles";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "~/components/general";

const ALL_ROLES = getAllRoles();

const WorkspaceRedirector = () => {
  const { user } = useAuth() as { user: UserType };

  const location = useLocation();

  const isWorkspaceURL = location.pathname.startsWith("/app/workspace");
  if (
    // @ts-ignore
    user?.role === ALL_ROLES.PORTAL_USER.VALUE &&
    !user?.oem &&
    !isWorkspaceURL
  )
    return <Navigate to="/app/workspace" replace />;
  return null;
};

export default WorkspaceRedirector;
